import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=ad596e52&scoped=true"
import script from "./AdminEdit.vue?vue&type=script&lang=js"
export * from "./AdminEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminEdit.vue?vue&type=style&index=0&id=ad596e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad596e52",
  null
  
)

export default component.exports